<vs-dialog [config]="{ dialogContainerClass: 'w-[350px] sm:w-[500px] max-w-[600px]' }" (closed)="onClosed()">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,
      hideCloseButton: saving,

      icon: 'send-01',
      iconTheme: 'primary',

      title: 'Record seller payout',
      subtitle: 'Record a payout already made to this seller outside WarrantySphere' + (contractNumber ? ' for ' + contractNumber : '') + '.'
    }"
  ></vs-dialog-header>

  <form [formGroup]="form" class="px-2 pt-4 flex flex-col gap-4">
    <vs-form-field
      [config]="{ label: 'Amount', description: 'How much was paid to the seller. Enter $0 if this was netted against an outstanding balance instead of paid out.' }"
    >
      <input
        vsInput
        currencyMask
        type="text"
        placeholder="$0.00"
        formControlName="amount"
        [options]="currencyMaskConfig"
      />
    </vs-form-field>

    <vs-form-field [config]="{ label: 'Payout date', description: 'Defaults to today.' }">
      <input vsInput type="date" formControlName="payoutDate" />
    </vs-form-field>

    <vs-form-field
      [config]="{ label: 'Payment method', description: 'Optional — e.g. \&quot;Check #1234\&quot;, \&quot;Wire transfer\&quot;.' }"
    >
      <input vsInput type="text" placeholder="How the seller was paid" formControlName="paymentMethod" />
    </vs-form-field>

    <vs-form-field
      [config]="{ label: 'Description', description: 'A note for this payout — which accounting record it corresponds to.' }"
    >
      <input
        vsInput
        type="text"
        placeholder="e.g. Commission paid via accounting system"
        formControlName="description"
      />
    </vs-form-field>

    <div class="flex gap-2 justify-end pt-2">
      <button vs-button appearance="outline" [disabled]="saving" (click)="close()">Cancel</button>
      <button vs-button theme="primary" [disabled]="form.invalid || saving" (click)="submit()">
        {{ saving ? 'Recording…' : 'Record payout' }}
      </button>
    </div>
  </form>
</vs-dialog>
